import BfpModalPage from "@faire/prototype-playground/workspace/ll/bfp-modal";
import PromotionModalPage from "@faire/prototype-playground/workspace/ll/promotion-modal";
import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

const BfpPromotionSetupPage = lazy(
  () => import("../../pages/BfpPromotionSetupPage")
);

import HighPotentialLeadsH2Page from "@faire/prototype-playground/workspace/ll/high-potential-leads-h-2";
import HplMvpPage from "@faire/prototype-playground/workspace/ll/hpl-mvp";
import HplWithTablePage from "@faire/prototype-playground/workspace/ll/hpl-with-table";
import LeadsOverviewAndPerformancePage from "@faire/prototype-playground/workspace/ll/leads-overview-and-performance";

const BfpStatesPage = lazy(() => import("../../pages/BfpStatesPage"));
const BrandLaunchesPage = lazy(() => import("../../pages/BrandLaunchesPage"));
const BrandAddProductPage = lazy(
  () => import("../../pages/BrandAddProductPage")
);
const BrandLaunchHighlightPage = lazy(
  () => import("../../pages/BrandLaunchHighlightPage")
);
const BrandMarketingPage = lazy(() => import("../../pages/BrandMarketingPage"));
const BrandProductsPage = lazy(() => import("../../pages/BrandProductsPage"));
const CustomerDetailActivityLogPage = lazy(
  () => import("../../pages/CustomerDetailActivityLogPage")
);

export function LanLamRoutes() {
  return (
    <Switch>
      <Route path="/ll/bfp-modal" component={BfpModalPage} />
      <Route path="/ll/bfp-states" exact component={BfpStatesPage} />
      <Route
        path="/ll/bfp-states/promotion/new/market"
        component={BfpPromotionSetupPage}
      />
      <Route
        path="/ll/bfp-states/promotion/new/shop-wide"
        component={BfpPromotionSetupPage}
      />
      <Route
        path="/ll/bfp-states/promotion/new/collection"
        component={BfpPromotionSetupPage}
      />
      <Route
        path="/ll/bfp-states/promotion/new/product"
        component={BfpPromotionSetupPage}
      />
      <Route
        path="/ll/bfp-states/promotion/new/promo-code"
        component={BfpPromotionSetupPage}
      />
      <Route path="/ll/brand-marketing" component={BrandMarketingPage} />
      <Route path="/ll/brand-products" component={BrandProductsPage} />
      <Route path="/ll/brand-add-product" component={BrandAddProductPage} />
      <Route
        path="/ll/brand-launch-highlight"
        component={BrandLaunchHighlightPage}
      />
      <Route
        path="/ll/customer-detail-activity-log"
        component={CustomerDetailActivityLogPage}
      />
      <Route path="/ll/brand-launches" component={BrandLaunchesPage} />
      <Route path="/ll/high-potential-leads-h-2" component={HighPotentialLeadsH2Page} />
      <Route path="/ll/hpl-mvp" component={HplMvpPage} />
      <Route path="/ll/hpl-with-table" component={HplWithTablePage} />
      <Route path="/ll/leads-overview-and-performance" component={LeadsOverviewAndPerformancePage} />
      <Route path="/ll/promotion-modal" component={PromotionModalPage} />
    </Switch>
  );
}

export const slug = "ll";
